import { AssetResponseAssetType } from 'generatedTypes/asset/models';

import { FLOATING_RESOURCE_ADD_MENU_OPTION } from 'components/FloatingResourceAddMenu/hooks/useData/constants';

import {
    APPLICATIONS_PAGE,
    APPLICATION_DETAILS_PAGE,
    ASSETS_PAGE,
    ASSET_DETAILS_PAGE,
    BATTERY_DETAILS_PAGE,
    BOUNDARIES_PAGE,
    BOUNDARY_DETAILS_PAGE,
    CLIENTS_PAGE,
    CLIENT_DETAILS_PAGE,
    DRONE_DETAILS_PAGE,
    FARMS_PAGE,
    FARM_DETAILS_PAGE,
    FIELDS_PAGE,
    FIELD_DETAILS_PAGE,
    USERS_PAGE,
    USER_DETAILS_PAGE
} from 'hooks/usePageRoutes/constants';

// Exact-match list routes (e.g. `/data/farms`) mapped to the resource the floating create
// button should default to when opened on that list view.
export const LIST_PAGE_RESOURCE: Record<string, FLOATING_RESOURCE_ADD_MENU_OPTION> = {
    [APPLICATIONS_PAGE]: FLOATING_RESOURCE_ADD_MENU_OPTION.APPLICATION,
    [ASSETS_PAGE]: FLOATING_RESOURCE_ADD_MENU_OPTION.ASSET,
    [BOUNDARIES_PAGE]: FLOATING_RESOURCE_ADD_MENU_OPTION.BOUNDARY,
    [CLIENTS_PAGE]: FLOATING_RESOURCE_ADD_MENU_OPTION.CLIENT,
    [FARMS_PAGE]: FLOATING_RESOURCE_ADD_MENU_OPTION.FARM,
    [FIELDS_PAGE]: FLOATING_RESOURCE_ADD_MENU_OPTION.FIELD,
    [USERS_PAGE]: FLOATING_RESOURCE_ADD_MENU_OPTION.MEMBER
};

// Prefix-match detail routes (e.g. `/data/farmDetails/:id`) mapped to the same resource as
// their list view. Battery and drone details resolve to ASSET since both are created through
// the asset form. Pages that own the corner for map drawing (application/boundary details)
// still hide the button themselves via useFloatingResourceAddContext(false), so their mapping
// here is inert.
export const DETAIL_PAGE_RESOURCE: Record<string, FLOATING_RESOURCE_ADD_MENU_OPTION> = {
    [APPLICATION_DETAILS_PAGE]: FLOATING_RESOURCE_ADD_MENU_OPTION.APPLICATION,
    [ASSET_DETAILS_PAGE]: FLOATING_RESOURCE_ADD_MENU_OPTION.ASSET,
    [BATTERY_DETAILS_PAGE]: FLOATING_RESOURCE_ADD_MENU_OPTION.ASSET,
    [BOUNDARY_DETAILS_PAGE]: FLOATING_RESOURCE_ADD_MENU_OPTION.BOUNDARY,
    [CLIENT_DETAILS_PAGE]: FLOATING_RESOURCE_ADD_MENU_OPTION.CLIENT,
    [DRONE_DETAILS_PAGE]: FLOATING_RESOURCE_ADD_MENU_OPTION.ASSET,
    [FARM_DETAILS_PAGE]: FLOATING_RESOURCE_ADD_MENU_OPTION.FARM,
    [FIELD_DETAILS_PAGE]: FLOATING_RESOURCE_ADD_MENU_OPTION.FIELD,
    [USER_DETAILS_PAGE]: FLOATING_RESOURCE_ADD_MENU_OPTION.MEMBER
};

// Asset details resolve to ASSET, but the asset form has a drone/battery sub-selection. On a
// battery or drone detail page the form should open to the matching tab. Other asset entry
// points (the assets list, the full menu) leave the form on its own default.
export const DETAIL_PAGE_ASSET_TYPE: Record<string, AssetResponseAssetType> = {
    [BATTERY_DETAILS_PAGE]: AssetResponseAssetType.BATTERY,
    [DRONE_DETAILS_PAGE]: AssetResponseAssetType.DRONE
};
